import React, { useState, useEffect } from 'react'
import Icon, { IconType } from '../Icon/Icon'


const JudgingRoundJudgeAssignment = (props) => {
  const {
    projects,
    assignments,
    judge,
    round,
    allJudges,
  } = props
  const [avgScore, setAvgScore] = useState(0)
  const [score, setScore] = useState(0)
  const [reassignTo, setReassignTo] = useState('')
  const availableReassignJudges = (allJudges || []).filter((j) => j.Id !== judge.Id)

  useEffect(() => {
    if (assignments?.length > 0) {
      let scored = assignments.filter(x => x.Score > 0);
      setScore(+(scored.length / assignments.length * 100).toFixed(2));
      let sum = scored.reduce( (acc, curr) => acc += +curr.Score, 0)
      setAvgScore(+(sum / scored.length).toFixed(2))
    }
  }, [assignments])




  const mappedAssignments = assignments?.map((a, i) => {
    if (projects[a.ProjectId]) {
      return (
        <span
          className="judge-assignment"
          key={`${a.ProjectId}&${i}`}
        >
          {a.Score
            &&
            <span
              v-if="a.Score"
              className="hover-success"
            >
              <i className="fa fa-check-square"></i>{a.Score.toFixed(2)}
            </span>
          }
          {projects[a.ProjectId].ProjectId}
          {props.coverageLocks?.[a.ProjectId] && (
            <span className="text-info" data-testid="assignment-coverage-lock">
              {' '}rubric open · {props.coverageLocks[a.ProjectId].judge}
              <button
                type="button"
                className="btn btn-default btn-xs bumper-left"
                data-testid="assignment-clear-lock"
                onClick={() => props.clearCoverageLock(a.ProjectId)}
              >
                Clear lock
              </button>
            </span>
          )}
          {round.Values.SchedulesInterviews
            ?
            <span
              className="interview-time"
            >&nbsp;
              {a.InterviewAt}
            </span>
            :
            a.FaildToSetInterview
            &&
            <span
              className="interview-time"
            >&nbsp;
              <i className="text-danger fad fa-calendar-day"></i>
            </span>
          }
          <span
            className="hover-danger"
            onClick={() => props.editAssignment(a.Id)}
            title="edit assignment"
          >
            <i className="fa fa-edit"></i>
          </span>
          <span
            className="hover-danger"
            onClick={() => props.removeAssignment(a.Id)}
            title='Remove assignment'
          >
            <i className="fa fa-trash-can"></i>
          </span>
        </span>
      )
    } else {
      return <></>
    }
  })

  const openMakeAssignment = () => {
    console.log('openMakeAssignment pressed')
    props.setSelectedProject({})
    props.setSelectedJudge(judge)
    props.setModalOpen(true)
  }

  // needs to open a make assignment
  // needs to be able to remove an assignment

  return (
    <div className="hover-shadow row-padding soft-border">
      <div className="row">
        <div className="col-sm-6">
          <div>
            <strong>{judge.FirstName} {judge.LastName}</strong>{' '}
            {judge.CheckedIn && (
              <span className="text-success" title="Checked In">
                <Icon type={IconType.UserCheck} addClass="fa-lg" />
              </span>
            )}
          </div>
          <div className='  small text-muted'>
            {judge.AssignedCategory && props.categories[judge.AssignedCategory]
              &&
              <strong><span className='cate-pref' title='Category Preference'>Assigned Category: {props.categories[judge.AssignedCategory]}</span></strong>
              }
              <div>
            {judge.Category1 && props.categories[judge.Category1]
              && 
              <span className='cate-pref' title='Category Preference'>{props.categories[judge.Category1]}</span> 
              }
            {judge.Category2 && props.categories[judge.Category2]
              &&
              <span className='cate-pref' title='Category Preference'>{props.categories[judge.Category2]}</span> 
              }
              
            {judge.Category3 && props.categories[judge.Category3]
              &&
              <span className='cate-pref' title='Category Preference'>{props.categories[judge.Category3]}</span> 
              }
              </div>
          </div>
          
          </div>
        <div className="col-sm-2 text-center">
          <span
            className="hover-success"
            onClick={openMakeAssignment} 
            title="Make assignment"
          >
            <i className="fad fa-box-open make-project-asgnm"></i>
          </span>
          {assignments?.length > 0
            &&
            <span className="badge">{assignments.length}</span>
          }
        </div>
        <div className="col-sm-4 text-right">
          {isNaN(avgScore) ? `` : `${avgScore} Avg Raw Score`}<br />
          {isNaN(avgScore) ? `` : `${score}% Complete`}<br />

          {availableReassignJudges.length > 0 && assignments?.length > 0 && (
            <select
              className="form-control"
              value={reassignTo}
              title="Reassign all assignments to another judge"
              onChange={(e) => {
                if (!e.target.value) return;
                props.reassignJudge(judge.Id, +e.target.value);
                setReassignTo('');
              }}
            >
              <option value="">Move Assignments to...</option>
              {availableReassignJudges
                .map((j) => (
                  <option key={j.Id} value={j.Id}>
                    {j.FirstName} {j.LastName}
                  </option>
                ))}
            </select>
          )}

        </div>
      </div>
      <div className="">
        <div className="judging-assignment-list">
          {mappedAssignments}
        </div>
      </div >
    </div >
  )
}

export default JudgingRoundJudgeAssignment